<template>
  <main-layout>
    <template slot="header-title">{{ $t('settings.title') }}</template>

    <template slot="main">
      <section class="container mx-auto" v-if="site">
        <div class="bg-white shadow rounded py-4 px-8">
          <k-tabs>
            <k-tab :name="$t('settings.tabs.details')" :selected="true">
              <about></about>
              <contact></contact>
            </k-tab>

            <k-tab :name="$t('settings.tabs.personalization')">
              <default-medias></default-medias>
              <customization v-if="me && me.accountmanager === 5"></customization>
            </k-tab>

            <k-tab :name="$t('settings.tabs.managers')">
              <managers></managers>
            </k-tab>

            <k-tab :name="$t('settings.tabs.translation')">
              <translations-campaigns></translations-campaigns>
              <translations-badges></translations-badges>
              <translations-events></translations-events>
              <translations-monsters></translations-monsters>
            </k-tab>

            <k-tab :name="$t('settings.tabs.integration')">
              <div class="section-parameter flex-col flex-wrap">
                <div class="col-left">
                  <h2>Global</h2>
                </div>
                <div class="col-right">
                  <div class="form-group">
                    <pre class="overflow-x-auto whitespace-pre-wrap break-words text-2xl p-6 rounded-3xl leading-8 text-white">
                                            <code>{{ code }}</code>
                    </pre>
                  </div>
                </div>
              </div>
            </k-tab>

            <k-tab :name="$t('settings.tabs.advanced')">
              <ips></ips>
              <languages></languages>
              <authentification></authentification>
            </k-tab>
          </k-tabs>
        </div>
      </section>
    </template>
  </main-layout>
</template>

<script>

import About from '@/components/settings/settings_about.vue'
import Contact from '@/components/settings/settings_contact.vue'
import DefaultMedias from '@/components/settings/settings_default_medias.vue'
import Customization from '@/components/settings/settings_customization.vue'
import Managers from '@/components/settings/settings_managers.vue'
import Authentification from '@/components/settings/settings_authentification.vue'
import Languages from '@/components/settings/settings_languages.vue'
import Ips from '@/components/settings/settings_ips.vue'
import TranslationsCampaigns from '@/components/settings/translations/translations_campaigns.vue'
import TranslationsBadges from '@/components/settings/translations/translations_badges.vue'
import TranslationsEvents from '@/components/settings/translations/translations_events.vue'
import TranslationsMonsters from '@/components/settings/translations/translations_monsters.vue'
import { mapGetters } from 'vuex'

export default {
  components: { TranslationsMonsters, About, Contact, DefaultMedias, Customization, Managers, Authentification, Languages, Ips, TranslationsCampaigns, TranslationsBadges, TranslationsEvents },
  data () {
    return {
      activeTab: 'details',
      code: null

    }
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    ...mapGetters('account', {
      admins: 'admins'
    }),
    ...mapGetters('user', {
      me: 'me'
    })
  },
  methods: {
    init () {
      if (this.site) {
        this.code =
`\n<div id='rocketfid'><\/div> \n\
<script type='text/javascript'> \n\
    var _dy={}; \n\
    _dy.account='` + this.site.sitekey + `'; \n\
    (function(){ \n\
        var dy=document.createElement('script');dy.type='text/javascript';dy.async=true; \n\
        dy.src=('https:'==document.location.protocol?'https://':'http://')+'rocketfid.com/rocketfid/rocketfid-core.js'; \n\
        var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(dy,s); \n\
    })();\n\
<\/script>`
      }
    }
  },

  created () {
    this.init()
  }
}
</script>

<style lang="scss">
    .section-parameter {
        border-top:1px solid #dedede;
        padding:24px 0;
        &:first-child {
            border:0;
        }

        h2 {
            font-size: 21px;
            font-weight: 600;
        }

        .form-group {
            label {
                font-weight: 600;
                font-size: 14px;
                display: block;
                margin-bottom: 8px;
            }

            input {
                width: 100%;
                background: #fff;
                border:1px solid #dedede;
                border-radius: 4px;
                display: block;
                line-height: 20px;
                font-size: 14px;
                padding: 6px 10px;
                color: rgb(46,46,46);
                box-sizing: border-box;
            }

            margin-bottom: 12px;

            &.two-columns {
               display: grid;
               grid-template-columns: 1fr 1fr;
               grid-column-gap: 24px;
            }
        }

        .form-submit {
            margin-top:24px;
            text-align: left;
        }
    }
    pre {
        background: #565656;
        font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Settings/Settings.vue